var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_677_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.62607 0 7.33022 0.265415 6.11241 0.796253C4.89461 1.31148 3.83295 2.02185 2.9274 2.9274C2.02185 3.83295 1.31148 4.89461 0.796253 6.11241C0.265415 7.33022 0 8.62607 0 10C0 11.3739 0.265415 12.6698 0.796253 13.8876C1.31148 15.1054 2.02185 16.1671 2.9274 17.0726C3.83295 17.9781 4.89461 18.6885 6.11241 19.2037C7.33022 19.7346 8.62607 20 10 20C11.3739 20 12.6698 19.7346 13.8876 19.2037C15.1054 18.6885 16.1671 17.9781 17.0726 17.0726C17.9781 16.1671 18.6885 15.1054 19.2037 13.8876C19.7346 12.6698 20 11.3739 20 10C20 8.62607 19.7346 7.33022 19.2037 6.11241C18.6885 4.89461 17.9781 3.83295 17.0726 2.9274C16.1671 2.02185 15.1054 1.31148 13.8876 0.796253C12.6698 0.265415 11.3739 0 10 0ZM14.2857 12.6932L10 8.40749L5.71429 12.6932L4.30913 11.2881L10 5.59719L15.6909 11.2881L14.2857 12.6932Z",
    fill: "#7D7566"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_677_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBtn);
export default __webpack_public_path__ + "static/media/active-btn.c0c95874ced1b9216cc355b89679ab2a.svg";
export { ForwardRef as ReactComponent };